export default "data:text/vtt;base64,V0VCVlRUCgowMDowMDowMC4wMDAgLS0+IDAwOjAwOjAzLjAwMApbVGltZXIgY2hpbWVdCg=="